<template>
  <div class="p-3 mb-5">
    <div class="d-flex justify-content-center">
      <div class="card w-100">
        <div class="card-header bg-main text-white h4 text-center position-relative">
          <strong>REPORTE DE DESPACHO</strong>
          <button type="button"
            class="btn btn-outline-main position-absolute end-0 top-50 translate-middle-y me-3 text-white"
            @click="returnHome">
            <i class="fas fa-home-lg-alt"></i> Inicio
          </button>
        </div>

        <div class="card-body w-100">
          <div class="row">
            <!-- FECHA DESDE -->
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
              <div class="input-group input-group-sm">
                <span class="input-group-text">Desde</span>
                <input type="date" class="form-control" v-model="filter.begindate" />
              </div>
            </div>

            <!-- FECHA HASTA -->
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
              <div class="input-group input-group-sm">
                <span class="input-group-text">Hasta</span>
                <input type="date" class="form-control" v-model="filter.enddate" />
              </div>
            </div>

            <!-- BOTÓN BUSCAR -->
            <div class="col-12 col-md-4 col-lg-2 col-xl-2 text-center">
              <button type="button" class="btn btn-sm btn-register text-white w-100" @click="mtdGetData">
                <i class="fas fa-search"></i> Buscar
              </button>
            </div>

            <!-- BUSCADOR -->
            <div class="col-12 col-md-6 col-lg-4 col-xl-4">
              <div class="input-group input-group-sm">
                <span class="input-group-text">Buscar</span>
                <input type="text" class="form-control" placeholder="Nombre" v-model="filter.search" />
              </div>
            </div>

            <!-- TABLA -->
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-2">
              <div class="table-container">
                <table id="consumos-table" class="table table-bordered border-main align-middle">
                  <thead class="header-sticky">
                    <tr class="text-center text-white font-size-ca" style="background: #900052; vertical-align: middle">
                      <th>N°</th>
                      <th>NOMBRE</th>
                      <th>FORMA FARM.</th>
                      <th>MARCA</th>
                      <th>MOLECULA</th>
                      <th>COMERCIAL</th>
                      <!-- <th>STOCK GENERAL</th>-->
                      <th>DESPACHOS</th>
                      <!--<th>DEVOLUCIONES</th>-->
                      <th>DETALLE DESPACHOS</th>
                    </tr>
                  </thead>

                  <tbody class="custom-table">
                    <tr v-if="filteredData.length == 0">
                      <td class="text-center align-middle" colspan="9">
                        {{ noRecordsMessage }}
                      </td>
                    </tr>

                    <tr v-for="(item, index) in filteredData" :key="index">
                      <td class="text-center align-middle">{{ index + 1 }}</td>

                      <td class="text-center align-middle">
                        {{ item.product?.subsubcategorie?.name || "-" }}
                      </td>

                      <td class="text-center align-middle">
                        {{ item.product?.subsubcategorie?.group?.name || "Sin Forma" }}
                      </td>

                      <td class="text-center align-middle">
                        {{ item.product?.brand?.name || "-" }}
                      </td>

                      <td class="text-center align-middle">
                        {{ item.product?.molecule || "-" }}
                      </td>

                      <td class="text-center align-middle">
                        {{ item.product?.commercial || "-" }}
                      </td>

                      <!-- <td class="text-center align-middle">
                        {{ getStock(item) }}
                      </td> -->

                      <td class="text-center align-middle">
                        {{ item.avg_quantity || 0 }}
                      </td>

                      <!-- <td class="text-center align-middle">
                        {{ item.avg_devolution || 0 }}
                      </td> -->

                      <td class="text-center align-middle no-print">
                        <div class="d-flex justify-content-center">
                          <a class="acciones-5 text-center px-2 py-2 bg-info" title="Ver despachos y devoluciones"
                            href="javascript:void(0)" style="margin-left: 2px"
                            @click="openModalViewDispatch(item.product?.id, index)">
                            <i class="fas fa-eye text-white"></i>
                          </a>
                        </div>
                      </td>
                    </tr>

                    <tr v-if="filteredData.length > 0" style="background: #f5e6ee; font-weight: bold">
                      <td colspan="8" class="text-end">TOTAL</td>
                      <td class="text-center align-middle color-main">{{ totals.quantity }}</td>
                      <td class="text-center align-middle color-main">{{ totals.devolution }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- FIN TABLA -->
          </div>
        </div>
      </div>
    </div>
    <cModalViewDispatch :title="modalViewDispatch.title" :boo_modal="modalViewDispatch.modal_form"
      :data="modalViewDispatch.data" @mtdCloseModalViewDispatch="mtdCloseModalViewDispatch" />
  </div>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";
import cModalViewDispatch from "../Modals/Consumos/cModalViewDetalleDispatch.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';

export default {
  components: {
    cModalViewDispatch,
    SweetAlert,
  },

  data() {
    return {
      swal: null,
      filter: {
        begindate: null,
        enddate: null,
        search: "",
      },
      cpData: [],
      noRecordsMessage: "No hay registros",
      modalViewDispatch: {
        title: "",
        modal_form: false,
        data: [],
      },
    }

  },
  created() {
    moment.locale("es");

    this.filter.begindate =
      moment().format("L").substr(6, 4) +
      "-" +
      moment().format("L").substr(3, 2) +
      "-01";

    this.filter.enddate =
      moment().format("L").substr(6, 4) +
      "-" +
      moment().format("L").substr(3, 2) +
      "-" +
      moment().format("L").substr(0, 2);
  },
  computed: {
    filteredData() {
      if (!this.filter.search || this.filter.search.trim() === "") {
        return this.cpData;
      }
      const search = this.filter.search.toLowerCase();
      return this.cpData.filter((item) => {
        if (!item.product) return false;
        const name = item.product?.subsubcategorie?.name?.toLowerCase() || "";
        return name.includes(search);
      });
    },
    totals() {
      return this.filteredData.reduce(
        (acc, item) => {
          const qty = item.avg_quantity || 0;
          const dev = item.avg_devolution || 0;
          acc.quantity += qty;
          acc.devolution += dev;
          return acc;
        },
        { quantity: 0, devolution: 0, consumed: 0 }
      );
    },
  },
  methods: {
    ...mapActions(["get", "post"]),

    returnHome() {
      this.$emit("returnHome");
    },
    mtdGetData() {
      this.post({
        url: this.$store.getters.get__url + "/Pharmacy/reporteDespachos",
        token: this.$store.getters.get__token,
        params: this.filter,
      })
        .then((response) => {
          this.cpData = response || [];
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getStock(item) {
      if (!item.product || !item.product.stock) return 0;
      return item.product.stock.reduce(
        (total, s) => total + Number(s.quantity || 0),
        0
      );
    },
    // ─── MODAL ────────────────────────────────────────────────────────────────
    openModalViewDispatch(payload, pos) {
      this.post({
        url: this.$store.getters.get__url + "/Pharmacy/detalleDespachos",
        token: this.$store.getters.get__token,
        params: { payload, filter: this.filter },
      })
        .then((response) => {
          this.modalViewDispatch = {
            title: "Detalle Despachos",
            modal_form: true,
            data: response.data,
          };
        })
        .catch((error) => {
          console.error(error);
        });
    },

    mtdCloseModalViewDispatch() {
      this.modalViewDispatch = { title: "", modal_form: false, data: [] };
    },
  }
}
</script>